import * as React from 'react'
import PropTypes from 'prop-types'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Media from '@oakwood/oui/Media'
import MediaReveal from '@oakwood/oui/MediaReveal'
import { ASPECT_RATIOS } from 'utils/constants'
import Container from 'components/Container'
import Section from 'components/Section'
import Typography from 'components/Typography'

export const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    ...theme.mixins.contain('var(--coa-content-max-width)'),
    display: 'grid',
    gridGap: theme.spacing(3),
    gridTemplateColumns: '105px auto',
    padding: 'var(--coa-container-spacing) 0',
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  mediaContainer: {},
  media: {},
  author: {},
  occupation: {
    color: theme.palette.text.secondary,
  },
}))

function ArticleAuthor(props) {
  const { author, mediaSrc, occupation, text } = props
  const classes = useStyles(props)

  return (
    <Section className={classes.root} gutters="margin">
      <Container maxWidth={false}>
        <div className={classes.content}>
          <div>
            <MediaReveal className={classes.mediaContainer} {...ASPECT_RATIOS.author}>
              <Media className={classes.media} src={mediaSrc} />
            </MediaReveal>
          </div>

          <div>
            <Typography component="p" variant="subtitle1" gutterBottom>
              <span className={classes.author}>{author}, </span>
              <span className={classes.occupation}>{occupation}</span>
            </Typography>

            <Typography variant="body2">{text}</Typography>
          </div>
        </div>
      </Container>
    </Section>
  )
}

ArticleAuthor.propTypes = {
  author: PropTypes.string,
  mediaSrc: PropTypes.string,
  occupation: PropTypes.string,
  text: PropTypes.string,
}

export default ArticleAuthor
